import { Container, Grid, Paper, Typography } from "@mui/material";
import { useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { IContactFormManage } from "../../_common/interface/contact/iContactFormManage";
import { PrimaryButton } from "../../_components/button/primary.button";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { toastr } from "../../_components/toastr/toastr";
import { contactFormService } from "../../_services/contactForm.service";

export function ContactForm() {

    const resetData = () => ({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const [data, setData] = useState<IContactFormManage>(resetData);
    const [isSaving, setSaving] = useState(false);

    function handleChange(event: any) {
        setData((__data) => { return { ...__data, [event.target.name]: event.target.value } });
    };

    function submit(e: any) {
        e.preventDefault();
        setSaving(true);

        return contactFormService
            .post(data)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    setData(resetData);
                },
                (e) => toastr.error(e)
            )
            .finally(() => setSaving(false));
    }

    return (
        <Container maxWidth="lg">

            <Paper sx={{ padding: 3 }}>

                <Typography variant="h3" textAlign="center" color="primary">Contact Us</Typography>
                <Typography variant="h6" textAlign="center" color="secondary" mb={2}>
                    Motorsport Ireland offices are open from 9am to 5pm, Monday to Friday, and closed for lunch between 1pm and 2pm.
                </Typography>

                <ValidatorForm
                    onSubmit={submit}
                    noValidate>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>

                            <Typography>
                                <b>Address:</b> Motorsport Ireland, 34 Dawson Street, Dublin 2, Ireland. <br/>
                                <b>Telephone:</b> + 353 1 6775628 <br/>
                                <b>Email:</b> info@motorsportireland.com <br/><br/>

                                In the case of emails, we would ask that you please always check that your message has been received at our end, as in some cases emails may be blocked by our security filters.
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Grid container spacing={2}>

                                <Grid item xs={12}>
                                    <TextValidatorHcs
                                        key="name"
                                        name="name"
                                        label="Name"
                                        fullWidth
                                        required
                                        validators={['required']}
                                        errorMessages={['Name is required']}
                                        value={data.name}
                                        onChange={handleChange}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextValidatorHcs
                                        key="email"
                                        name="email"
                                        label="Email"
                                        fullWidth
                                        required
                                        validators={['required', 'isEmail']}
                                        errorMessages={['Email is required', 'Email is not valid']}
                                        value={data.email}
                                        onChange={handleChange}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextValidatorHcs
                                        key="subject"
                                        name="subject"
                                        label="Subject"
                                        fullWidth
                                        required
                                        validators={['required']}
                                        errorMessages={['Subject is required']}
                                        value={data.subject}
                                        onChange={handleChange}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextValidatorHcs
                                        key="message"
                                        name="message"
                                        label="Message"
                                        fullWidth
                                        required
                                        validators={['required']}
                                        errorMessages={['Message is required']}
                                        value={data.message}
                                        onChange={handleChange}
                                        multiline
                                        rows={4}
                                    />
                                </Grid>


                                <Grid item xs={12}>
                                    <PrimaryButton
                                        isSaving={isSaving}
                                        type="submit"
                                        variant="save">{"Submit"}
                                    </PrimaryButton>
                                </Grid>

                            </Grid>

                        </Grid>

                    </Grid>

                </ValidatorForm>

            </Paper>

        </Container>
    );

}
